export default "__VITE_ASSET__BRZ9RHnk__"